import { render, staticRenderFns } from "./ApplyPersonDialog.vue?vue&type=template&id=28f243b4&scoped=true&"
import script from "./ApplyPersonDialog.vue?vue&type=script&lang=ts&"
export * from "./ApplyPersonDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ApplyPersonDialog.vue?vue&type=style&index=0&id=28f243b4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f243b4",
  null
  
)

export default component.exports